import { Button, Checkbox, Col, Form, message, Row, Space } from "antd";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import InputBox from "../../../components/common/input";
import DropdownSelect from "../../../components/common/select";
import FileUpload from "../../../components/common/upload-file/FileUpload";
import { toast } from "react-toastify";
import { addAdvertisement, updateAdvertisement, viewAdvertisement } from "../../../redux/reducer/AdvertisementSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocale } from "antd/es/locale";
import { urlConstant } from "../../../constants/urlConstant";
import FileUploadFun from "../../../components/common/fileUploadFun/FileUploadFun";
import { uploadFile } from "../../../redux/reducer/UploadSlice";
import FileUploadTwo from "../../../components/common/fileUploadFun/FileUploadTwo";
const options = [
  { label: "Option 1", value: "1" },
  { label: "Option 2", value: "2" },
  { label: "Option 3", value: "3" },
];
const AddAdvertising = () => {
  const navigate = useNavigate();
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [form] = Form.useForm();
  const dispatch = useDispatch()
  const location = useLocation()
  const editData = location.state?.editData || null;
  const [imageData, setImageData] = useState({ 
    url_en: "" || "https://pixabay.com/photos/roche-balance-pink-granite-coast-9485693/",
    url_es: "" || "https://pixabay.com/photos/roche-balance-pink-granite-coast-9485693/",
    url_pt: "" || "https://pixabay.com/photos/roche-balance-pink-granite-coast-9485693/",
  })
  const [previewImages, setPreviewImages] = useState(()=>({
    url_en: "",
    url_es: "" ,
     url_pt: "",
  }))

  

  const {addAdLoading, viewAd} = useSelector((prev) => prev?.advertisement)

  
  const handleUploadSuccess = (field, url) => {
    form.setFieldsValue({ [field]: url });
  
  };


  useEffect(() => {
    if (editData) {
      // dispatch(viewHomeCategory(editData?.id));
      dispatch(viewAdvertisement(editData?.id))
    }
  }, [dispatch, editData]);


  useEffect(() => {
    if (viewAd && editData) {
      form.setFieldsValue({
        title_en: viewAd?.title_en,
        title_es: viewAd?.title_es,
        title_pt: viewAd?.title_pt,
        position: viewAd?.position,
        url_en: viewAd?.url_en,
        url_es: viewAd?.url_es,
        url_pt: viewAd?.url_pt,
        link_en: viewAd?.link_en, // ✅ added

      });


      setPreviewImages({
        url_en: viewAd.url_en
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewAd.url_en}`
          : "",
        url_es: viewAd.url_es
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewAd.url_es}`
          : "",
        url_pt: viewAd.url_pt
          ? `${process.env.REACT_APP_IMAGE_URL}/${viewAd.url_pt}`
          : "",
      });

      // setImageData((prev) => ({...prev,  url_en: viewAd?.url_en,
      //   url_es: viewAd?.url_es,
      //   url_pt: viewAd?.url_pt}))
    } else {
      form.resetFields(); // Ensure blank form on add
    }
  }, [editData, viewAd, form]);


  const handleChange = (value) => {
    setSelectedValue(value);
  };

  const positionData = [{ label: "Bottom", value: 0 }, { label: "Top", value: 1 }]

  const {uploadLoading} = useSelector(prev => prev?.upload)

  // const handleFileUploadEn = async (file) => {
  //   const data = await dispatch(uploadFile(file));
  //   if(data.type === "upload/uploadFile/fulfilled"){
  //     setImageData(prev => ({...prev, url_en: data?.payload?.result?.rows?.[0]?.image_url }))
  //   }
    

  // }
  // const handleFileUploadEs = async (file) => {
  //   const data = await dispatch(uploadFile(file));
  //   if(data.type=== "upload/uploadFile/fulfilled"){
  //     setImageData(prev => ({...prev, url_es: data?.payload?.result?.rows?.[0]?.image_url }))
  //   }
  // }
  // const handleFileUploadPt = async (file) => {
  //   const data = await dispatch(uploadFile(file));
  //   if(data.type=== "upload/uploadFile/fulfilled"){
  //     setImageData(prev => ({...prev, url_pt: data?.payload?.result?.rows?.[0]?.image_url }))
  //   }
  // }

  

  const onFinish = async (values) => {
    const formData = {
      title_en: values.title_en,
      title_es: values.title_es,
      title_pt: values.title_pt,
      position: values.position,
      url_pt: values?.url_pt,
      url_es: values?.url_es,
      url_en: values?.url_en,
      link_en: values?.link_en
    };



    try {
      let response;
      if (editData) {
        // Update existing category
        response = await dispatch(updateAdvertisement({ id: editData.id, data: formData }));
        if(response.type === "advertisement/update/fulfilled"){
          toast.success("Advertising updated successfully")
          navigate(-1);
        }   
      } else {
        // Add new category
        response = await dispatch(addAdvertisement(formData));
      }
      if (response?.payload?.code === 201 || response?.type === "celebrityCategory/update/fulfilled") {
        toast.success(response?.payload?.message)
        navigate('/advertising');
      }
    } catch (error) {
      message.error("Something went wrong. Please try again.");
    }
  };

  return (
    <div>
      <div className="addBtnBx dflex">
        <div className="tableHeading">{editData ? "Edit" : "Add"} Advertising Details</div>
        <Space>
          <Button onClick={() => navigate(-1)}>Cancel</Button>
          <Button type="primary" onClick={() => form.submit()} loading={addAdLoading}>
            {editData ? "Update Details" : "Save Details"}
          </Button>
        </Space>
      </div>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row gutter={16}>
          <Col xs={24} sm={8}>
            <Form.Item
              //  label={<span>Title  (en)<span style={{ color: "red" }}>*</span></span>}
              label="Title"
              name="title_en"
              rules={[{ required: true, message: "Please enter  Title (en)" }]}
            >
              <InputBox size="large" placeholder="Enter Title (en)" />
            </Form.Item>
          </Col>


          <Col xs={24} sm={8}>
            <Form.Item
              name="position"
              label="Banner Position"
              rules={[{ required: true, message: "Enter Banner Position" }]}
            >
              <DropdownSelect

                options={positionData}
                placeholder="Choose..."
                value={selectedValue}
                onChange={(value) => {
                  form.setFieldsValue({ position: value });
                }}
                menu={{ items: positionData.map((item) => ({ label: item.label, key: item.value })) }}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item label="Add Link" name="link_en">
              <InputBox size="large" placeholder="Add Link" />
            </Form.Item>
          </Col>
        </Row>

        {/* ✅ Next row for images */}
        <Row gutter={16} className="mt-4">
          <Col xs={24} sm={8}>
            <Form.Item
              name="url_en" label="Upload Image (en)"
              rules={[
                { required: true, message: "Please upload a Image" },
              ]}
            >
              <FileUploadTwo
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("url_en", url)}
                initialPreview={editData ? `${previewImages.url_en}` : ""}
              />
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item
              name="url_es" label="Upload Image (es)"
              rules={[
                { required: true, message: "Please upload a Image" },
              ]}
            >
              <FileUploadTwo
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("url_es", url)}
                initialPreview={editData ? `${previewImages.url_es}` : ""}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item
              name="url_pt" label="Upload Image (pt)"
              rules={[
                { required: true, message: "Please upload a Image" },
              ]}
            >
              <FileUploadTwo
                maxFileSizeText={
                  "Max file size: 1MB, Supports .jpeg, .jpg and .png formats"
                }
                setFieldValue={(url) => handleUploadSuccess("url_pt", url)}
                initialPreview={editData ? `${previewImages.url_pt}` : ""}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AddAdvertising;
